import React from 'react';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    List,
    ListItem,
    Paper,
    TextField,
    Typography
} from '@mui/material';
import i18n from '../../i18n';
import ListItemText from '@mui/material/ListItemText';
import SendIcon from '@mui/icons-material/Send';
import { fDateTime } from '../../utils/formatTime';
import { AppDataContext } from '../../context/Context';
import { formatName } from '../../utils/formatName';
import CloseIcon from '@mui/icons-material/Close';

export default class CommentsDialog extends React.Component {
    onCancel = () => {};
    fetchData = () => {};

    constructor(props) {
        super(props);

        this.state = {
            dialogOpen: props.dialogOpen || false,
            dialogData: props.dialogData || [],
            newComment: '',
            error: ''
        };

        this.onCancel = props.onCancel;
        this.fetchData = props.fetchData;
    }

    static getDerivedStateFromProps(props, state) {
        if (
            props.dialogOpen !== state.dialogOpen ||
            props.dialogData !== state.dialogData
        ) {
            return {
                dialogOpen: props.dialogOpen,
                dialogData: props.dialogData
            };
        }

        return null;
    }
    static contextType = AppDataContext;

    handleAddComment = () => {
        const newComment = this.state.newComment.trim();
        if (!newComment) return;

        const id = this.props.id;
        const type = this.props.type;
        const controller = this.props.controller;
        this.context
            .getState()
            .server[controller].add({
                comment: newComment,
                [type + 'Id']: id,
            })
            .then(() => {
                this.setState({
                    newComment: ''
                });
                this.fetchData();
            })
            .catch((error) => {
                this.setState({
                    error: error.message
                });
            });
    };

    render() {
        const { newComment, error, dialogData } = this.state;
        return (
            <Dialog open={this.state.dialogOpen} onClose={this.onCancel} maxWidth="sm" fullWidth={!!dialogData?.length}>
                <DialogTitle>
                    {i18n.t('dialogs.commentsTitle')}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={this.onCancel}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent>
                    <List
                        sx={{
                            overflow: 'auto',
                            pt: '20px'
                        }}
                    >
                        {dialogData?.length === 0 && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '200px',
                                    color: '#999999'
                                }}
                            >
                                <Typography variant="body1">
                                    {i18n.t('dialogs.noComments')}
                                </Typography>
                            </Box>
                        )}
                        {dialogData?.map((item, index) => {
                            const user = item.user || {};
                            return (
                                <ListItem key={index}>
                                    <ListItemText
                                        primary={item.comment}
                                        secondary={` ${fDateTime(
                                            item.dateCreated
                                        )} - ${formatName(
                                            user.firstName,
                                            user.lastName
                                        )}`}
                                        primaryTypographyProps={{
                                            borderRadius: '10px',
                                            padding: '10px',
                                            marginBottom: '4px',
                                            textAlign: 'start',
                                            backgroundColor: '#f5f5f5'
                                        }}
                                        secondaryTypographyProps={{
                                            textAlign: 'end'
                                        }}
                                    />
                                </ListItem>
                            );
                        })}
                    </List>

                    <Paper
                        elevation={1}
                        style={{
                            padding: '8px',
                            display: 'flex',
                            alignItems: 'center',
                            marginTop: '16px'
                        }}
                    >
                        <TextField
                            autoFocus
                            fullWidth
                            error={!!error}
                            helperText={error}
                            label={i18n.t('dialogs.commentsLabel')}
                            variant="outlined"
                            value={newComment}
                            onChange={(e) =>
                                this.setState({ newComment: e.target.value })
                            }
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    this.handleAddComment();
                                }
                            }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() =>
                                                this.handleAddComment()
                                            }
                                            disabled={!newComment}
                                            edge="end"
                                        >
                                            <SendIcon />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Paper>
                </DialogContent>
            </Dialog>
        );
    }
}
